import { useToast } from 'vue-toastification'
export default function () {
  return useToast()
}
